import apiClient from 'api';
const compassServerApiPath = window.env.REACT_APP_SERVER_API_PATH;

/**
 * Fetch customer logo from backend endpoing /customer/logo
 * @returns {object} base64 logo image and type
 */
export const fetchLogoImg = async () => {
  return await apiClient.get(compassServerApiPath, '/customer/logo');
};

/**
 * Send base64 encoded string to backend endpoint /customer/logo
 * @param {string} logoImg - base64 encoded string
 */
export const createLogoImg = async logoImg => {
  return await apiClient.post(compassServerApiPath, '/customer/logo', logoImg);
};
